import React, { useEffect, useState } from 'react'
import { TabView, TabPanel } from 'primereact/tabview';
import { useSelector, useDispatch } from 'react-redux';
import { getFilteredMenus } from '../../common/helpers/permissions';
import TrainingDashboardComponents from './training-dashboard-components';
// import TrfListing from './trf-listing';
import TrfList from './trf-list';
import MyTrainings from './my-trainings';
import TeamTraining from './team-training';
import UploadTrainingDocuments from './upload-training-documents';
import { TRAINING_BU_HEAD, TRAINING_ADMIN, TRAINING_HR, TRAINING_MANAGER, TRAINING_PEER_REVIEWER, TRAINING_MENU_VIEW, TRAINING_TRAINER } from '../../config/permissions';
import './styles/style.scss';
import AdminTrfListing from './admin-trf-listing';
import TrainerView from './trainer-view';

const TrainingDashboard = () => {
    const { user } = useSelector(e => e.user);

    const items = [
        { header: 'Dashboard', component: <TrainingDashboardComponents />, permissions: [TRAINING_MENU_VIEW] },
        // { header: 'TRF Forms', component: <TrfListing />, permissions: [TRAINING_PEER_REVIEWER] },
        { header: 'TRF Forms', component: <TrfList />, permissions: [TRAINING_PEER_REVIEWER] },
        { header: 'Trainer', component: <TrainerView />, permissions: [TRAINING_TRAINER] },
        { header: 'TRF Forms (TM)', component: <AdminTrfListing />, permissions: [TRAINING_MANAGER] },
        { header: 'My Training', component: <MyTrainings />, permissions: [TRAINING_MENU_VIEW] },
        { header: 'Team Training', component: <TeamTraining />, permissions: [TRAINING_PEER_REVIEWER] },
        { header: 'Upload Assesment/Feedback', component: <UploadTrainingDocuments />, permissions: [TRAINING_MANAGER] },
    ]

    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        setMenuItems(getFilteredMenus(items));
    }, [])

    return (
        <div className='ess-page'>
            <TabView>
                {menuItems?.map(x => <TabPanel header={x?.header}>{x?.component}</TabPanel>)}
            </TabView>
        </div>
    )
}

export default TrainingDashboard